const e = {
  modal: 1300,
  zeroLayer: 0,
  firstLayer: 1,
  secondLayer: 2,
  header: 1001,
  loader: 30
};
export {
  e as zIndex
};
//# sourceMappingURL=zIndex.mjs.map
